<xux-icon-defs></xux-icon-defs>
<xux-drawer-container [class.no-navbar]="navbarHidden$ | async" [class.no-footer]="isIframeMode$ | async">
  <xux-drawer-sidebar class="xux-drawer-sidebar">
    <xux-navigation
      [menuItems]="menuItems$ | async"
      [hiddenMenu]="hiddenMenu$ | async"
      *ngIf="user$ | async"
    ></xux-navigation>
  </xux-drawer-sidebar>

  <xux-drawer-content class="xux-drawer-content">
    <xux-breadcrumb-navbar
      class="breadcrumb-nav"
      *ngIf="user$ | async"
      [isIframeMode]="isIframeMode$ | async"
      [selectedMenuItem]="selectedMenuItem$ | async"
      [buttons]="breadcrumbButtons$ | async"
      [appName]="I18n.Application.VenuesInventory"
    ></xux-breadcrumb-navbar>
    <div class="content-box">
      <router-outlet></router-outlet>
    </div>
    <xvi-notifications></xvi-notifications>
  </xux-drawer-content>
</xux-drawer-container>
<xux-loader [isVisible]="loader$ | async" [params]="progressBarLoader$ | async"></xux-loader>
<xvi-company-selection></xvi-company-selection>
<xvi-modals-controller></xvi-modals-controller>
<xux-footer *ngIf="!(isIframeMode$ | async)"></xux-footer>
<template #dropDownMenuContainer></template>
